import { useQuery } from "react-query";
import { tableHeaders, columnNames } from "./utils";
import CardTopTable from "components/Cards/CardTopTable";
import CardTable from "components/Cards/CardTable";
import { fetchUsers } from "services/fetchData";
// components

export default function User() {
  const { data, status } = useQuery("users", fetchUsers);
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <CardTopTable
            title="View, Edit, Add User"
            link="/admin/users/add"
            linkName="Add New User"
          />
          <CardTable
            color="dark"
            name="SUPPLIERS"
            tableHeaderArr={tableHeaders}
            columnNamesArr={columnNames}
            tableData={data}
            status={status}
          />
        </div>
      </div>
    </>
  );
}
